import { useState } from 'react';

import { useMediaPlayerContext } from '@/components/app/contentPlayer/MediaPlayerProvider';
import ShareButton from '@/components/app/contentPlayer/ShareButton';
import ShareModal from '@/components/app/contentPlayer/ShareModal';
import { useProgramState } from '@/hooks/store';
import getUrl from '@/utils/getUrl';

import ProgramFavorite from './ProgramFavorite';
import { Wrapper } from './styles';

const ProgramActions = () => {
	const program = useProgramState();
	const { hideControls } = useMediaPlayerContext();
	const [isModalOpen, setIsModalOpen] = useState(false);

	if (!program) {
		return null;
	}

	const shareUrl = `${getUrl('www')}/app/program/${program.id}`;
	return (
		<Wrapper>
			{!hideControls && <ProgramFavorite shouldShowText id={program.id} title={program.title} />}
			<ShareButton shouldShowText isShareModalVisible={setIsModalOpen} />
			<ShareModal shareUrlOverrides={shareUrl} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
		</Wrapper>
	);
};

export default ProgramActions;
